module.exports = __webpack_public_path__ + "img/6.b2b2a8a9.jpg";